export const MAX_AUTHOR_FUNCTIONS_FOR_PREFILL = 4;
